export const MESSAGE_HOME_REDIRECT =
  'https://www.gndi.com.br/noticias/mensagem-exclusiva-para-clientes-de-pequena-e-media-empresa';
